import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,NavigationEnd, Router } from '@angular/router';

export interface IMenuOption {
  label: string;
  active: boolean;
  routeUrl?: string;
  sideMenuicon:string



}
@Component({
  selector: 'rsb-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuOptions: Array<IMenuOption> = [
    {
      label: 'Dashboard',
      active: true,
      routeUrl:'dashboard',
      sideMenuicon:'assets/img/dashboard.svg'
    },
    {
      label: 'My Profile',
      active: false,
      routeUrl:'myProfile',
      sideMenuicon:'assets/img/Viewed Leads.svg'
    },
    {
      
      label: 'Post Property',
      active: false,
      // routeUrl:'post-property/new',
      routeUrl:'propertyModules',
      sideMenuicon:'assets/img/projectfinance.svg'

    
    },
   
    {
      label: 'My Properties',
      active: false,
      routeUrl:'myProperties',
      sideMenuicon:'assets/img/myproperty.svg'

    
    },
    {
      label: 'My Projects',
      active: false,
      routeUrl:'myProjects',
      sideMenuicon:'assets/img/myproject.svg'
     },
     {
      
      label: 'My Leads',
      active: false,
      routeUrl:'leads',
      sideMenuicon:'assets/img/projectfinance.svg'    
    },
    {
      
      label: 'View Leads',
      active: false,
      routeUrl:'myViewLead',
      sideMenuicon:'assets/img/Viewed Leads.svg'
    },
    {
      
      label: 'Sales',
      active: false,
      routeUrl:'sales',
      sideMenuicon:'assets/img/sale.svg'

    
    },
    {
      
      label: 'Loans',
      active: false,
      routeUrl:'loans',
      sideMenuicon:'assets/img/loan.svg'

    
    },
    
    {
      
      label: 'CIBIL Score',
      active: false,
      routeUrl:'cibil',
      sideMenuicon:'assets/img/cibil.svg'

    
    },
    
   
    {
      
      label: 'Project Finance',
      active: false,
      routeUrl:'projectFinance',
      sideMenuicon:'assets/img/projectfinance.svg'

    
    },
    {
      
      label: 'CCTV Enquiry',
      active: false,
      routeUrl:'cctvEnquiry',
      sideMenuicon:'assets/img/cctv.svg'

    
    },
    {
      
      label: 'Interior Design Enquiry',
      active: false,
      routeUrl:'interiorDesignEnquiry',
      sideMenuicon:'assets/img/Interior Design Enquiry.svg'

    
    },
    {
      
      label: 'Solar Enquiry',
      active: false,
      routeUrl:'solarEnquiry',
      sideMenuicon:'assets/img/Solar Enquiry.svg'

    
    },
    {
      
      label: 'Reviews & Ratings',
      active: false,
      routeUrl:'reviewsAndRatings',
      sideMenuicon:'assets/img/Reviews.svg'

    
    },

   
    // {
      
    //   label: 'Lead Center',
    //   active: false,
    //   routeUrl:'',
    //   sideMenuicon:'ri-group-3-line'

    
    // },
    // {
    //   label: 'Deals',
    //   active: false,
    //   routeUrl:'',
    //   sideMenuicon:'ri-shake-hands-line'

    
    // },
    // {
    //   label: 'Loans',
    //   active: false,
    //   routeUrl:'',
    //   sideMenuicon:'ri-money-rupee-circle-line'

    
    // },
    // {
    //   label: 'Support',
    //   active: false,
    //   routeUrl:'',
    //   sideMenuicon:'ri-settings-2-line'

    
    // },
  ]
  subMenuOpenFlag: boolean = false;
  currentUrl;
  constructor( 
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url !== '/') {
          const split = val.url.split('/');
          if (split.length === 2) {
            this.currentUrl = split[1];
            if (this.currentUrl) {
              this.menuOptions.map((obj) => {
                if (obj.routeUrl === this.currentUrl) {
                  obj.active = true;
                } else {
                  obj.active = false;
                }
              })
            }
          }
        }
      }
    })
  }
  openMenuItem(menu: IMenuOption): void {
    if (!menu.active) {
      this.menuOptions.forEach(item => {
        item.active = false;
      });
    }
    this.subMenuOpenFlag = false;
    menu.active = !menu.active;
    // if(menu.routeUrl === 'ecommerce') {
    //   window.open('http://www.indiastudent.com/admin/#/ecommerce', '_blank');
    // }
    // else 
    if (menu.routeUrl && menu.active) {
      this.router.navigate([menu.routeUrl]);
    }
  }
  

}
